class Person {

  constructor (data) {
    if (data !== undefined) {
      Object.entries(data).forEach(([key, value]) => {
        this[key] = value
      })
    }
  }

  prepareForSend () {
    let data = _.cloneDeep(this)
    return data
  }
}

export {
  Person as default
}



// WEBPACK FOOTER //
// ./src/models/place.js